import { FC, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnClickOutside } from '../../hooks/onClickOutside';
import { Icon } from '../Icon';
import './FilterGroup.css';

type FilterProps = {
  children: React.ReactNode;
  isActive?: boolean;
};

export const FilterGroup: FC<FilterProps> = ({ isActive, children }) => {
  const [showFilter, setShowFilter] = useState(false);

  const ref = useRef(null);
  useOnClickOutside(ref, () => setShowFilter(false));

  const { t } = useTranslation();

  const classes = useMemo(
    () =>
      [
        ...(function* () {
          if (isActive || showFilter) {
            yield 'border-blue-100 text-blue-200';
          } else {
            yield 'border-gray-500 text-gray-700';
          }
          yield 'p-1 border hover:border-blue-100 hover:text-blue-100 focus:shadow-2dp focus:outline-none rounded flex items-center';
        })(),
      ].join(' '),
    [isActive, showFilter],
  );

  return (
    <div
      ref={ref}
      >
      <button
        className={classes}
        onClick={() => setShowFilter(!showFilter)}
        data-testid="show-filters"
      >
        <div className="w-8 h-8 p-2">
          <Icon name={'Filter'} />
        </div>
        <div className="hidden pr-2 font-regular sm:block">
          {t('translation:components:filters:filter')}
        </div>
      </button>
      {showFilter && (
        <div className="absolute z-10 w-full p-4 mt-2 bg-gray-100 shadow-2dp __filter__">
          {children}
        </div>
      )}
    </div>
  );
};
